module.exports = __webpack_public_path__ + "img/cannshareca.c2640240.png";